module.exports = __webpack_public_path__ + "img/Vietnam-4.50db1f34.jpg";